/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module DiagramModules
 */

import {
    Component,
    Input,
} from '@angular/core';
import './label-count-legend.component.less';
import {
    ILabelRowData,
} from '../label-count-row';

/**
 * Data format needed for alert message.
 */
export type TLabelCountLegendAlertMessage = {
    label: string;
    description?: string;
    count?: number;
};

/**
 * @description
 *      Reusable component acting as legend, for labeling data; mostly for charts/graphs.
 * @author Akul Aggarwal
 */
@Component({
    selector: 'label-count-legend',
    templateUrl: './label-count-legend.component.html',
})
export class LabelCountLegendComponent {
    @Input()
    public readonly labelList: ILabelRowData[];

    /**
     * Optional title displayed.
     */
    @Input()
    public title?: string;

    /**
     * Same as labelList format, for bottom section.
     */
    @Input()
    public summarySectionLabel?: ILabelRowData;

    /**
     * Optional alert messages to show.
     */
    @Input()
    public alertMessages: TLabelCountLegendAlertMessage[];

    public trackByIndex(index: number): number {
        return index;
    }
}
